//'use strct';

export default class News {
	constructor() {
        (function($) {
            if($('.news-block').length > 0){
                var $mobile = $(window).outerWidth() < 769;

                $(".image-slider").slick({
                    infinite: true,
                    slidesToScroll: 1,
                    centerMode:true,
                    adaptiveHeight: false,
                    variableWidth: true,
                    responsive:[
                        {
                          breakpoint: 769,
                          settings: {
                            centerPadding: '50px',
                            adaptiveHeight: true,
                            variableWidth: false
                          }
                        },
                        {
                          breakpoint: 420,
                          settings: {
                            centerPadding: '25px',
                            adaptiveHeight: true,
                            variableWidth: false
                          }
                        }
                    ]
                })

                $(".news-slider").slick({
                    infinite: true,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    responsive:[
                        {
                          breakpoint: 1024,
                          settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                          }
                        },
                        {
                          breakpoint: 767,
                          settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                          }
                        }
                    ]
                }).on('afterChange',function(){
                    var $current = $(".news-slider .slick-active").data('slick-index') + 1;
                    if ($current < 10){ $current = "0" + $current; }

                    $('.num-holder .current').text($current);
                })

                if($mobile){
                    var slickTrackHeight = $('.news-slider .slick-track').height();
                    $('.news-slider .slick-slide').css('height', slickTrackHeight + 'px');

                    var $total = $('.slick-slide').length - $('.slick-cloned').length;
                    var $current = $(".news-slider .slick-active").data('slick-index') + 1;

                    if ($total < 10){ $total = "0" + $total; }
                    if ($current < 10){ $current = "0" + $current; }

                    $('.news-slider .num-holder .current').text($current);
                    $('.news-slider .num-holder .total').text($total);
                }
            }
        })(jQuery);
	}
}